import React from "react"
import { Box, Typography } from "src/UILibrary"
import { useTranslation } from "react-i18next"
import InputDateField from "src/components/atom/InputDateField"
import { Dayjs } from "dayjs"
import { useMediaQuery } from "react-responsive"

interface Props {
  fromDate: Dayjs | null
  toDate: Dayjs | null
  handleFromDate: any
  handleToDate: any
}

export const NewsSearchItem = ({ fromDate, toDate, handleFromDate, handleToDate }: Props) => {
  const { t } = useTranslation("translation", { keyPrefix: "mypage.inbox" })
  const isTablet = useMediaQuery({ query: "(min-width: 1200px)" })

  return (
    <>
      {isTablet ? (
        <Box
          sx={{
            mt: "50px",
            mx: "0px",
            p: "10px 20px",
            bgcolor: "#F1F1F1",
          }}
        >
          <Typography.SubTitle
            className="notosans weight400"
            sx={{ mt: "0px" }}
            color="textPrimary"
            fontSize={14}
          >
            {t("search_by_date")}
          </Typography.SubTitle>

          <InputDateField date={fromDate} size={12} handleDate={handleFromDate} />
          <InputDateField date={toDate} size={12} handleDate={handleToDate} />
        </Box>
      ) : (
        <>
          <Box>
            <Typography.SubTitle
              className="notosans weight400"
              sx={{ mt: "0px" }}
              color="textPrimary"
              fontSize={14}
            >
              {t("search_by_date")}
            </Typography.SubTitle>

            <InputDateField date={fromDate} size={12} handleDate={handleFromDate} />
            <InputDateField date={toDate} size={12} handleDate={handleToDate} />
          </Box>
        </>
      )}
    </>
  )
}
